var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplete1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 30C5 16.1929 16.1929 5 30 5C43.807 5 55 16.1929 55 30C55 43.807 43.807 55 30 55C16.1929 55 5 43.807 5 30ZM39.2677 23.2322C40.244 24.2085 40.244 25.7915 39.2677 26.7677L30.0607 35.9748C28.6465 37.389 26.3535 37.389 24.9392 35.9748L20.7322 31.7677C19.7559 30.7915 19.7559 29.2085 20.7322 28.2323C21.7085 27.256 23.2915 27.256 24.2678 28.2323L27.5 31.4645L35.7323 23.2322C36.7085 22.2559 38.2915 22.2559 39.2677 23.2322Z",
    fill: "#4ECB71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete1);
export default __webpack_public_path__ + "static/media/complete-1.036250d105b4705bf071d85193abba8a.svg";
export { ForwardRef as ReactComponent };